"use client";

import { createContext, useContext } from "react";
export interface SelfSchedulePatientDetailsContextValue {
  ready: boolean;
  /** Defer the auth continuation, not authentication itself, until details are saved. */
  afterDetails: (patientId: string, continuation: () => void) => void;
}
export const SelfSchedulePatientDetailsContext = createContext<SelfSchedulePatientDetailsContextValue | null>(null);
export function useSelfSchedulePatientDetails() {
  return useContext(SelfSchedulePatientDetailsContext);
}